import { render, staticRenderFns } from "./WorktimeTag.vue?vue&type=template&id=4bfb19ad&scoped=true&"
import script from "./WorktimeTag.vue?vue&type=script&lang=js&"
export * from "./WorktimeTag.vue?vue&type=script&lang=js&"
import style0 from "./WorktimeTag.vue?vue&type=style&index=0&id=4bfb19ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb19ad",
  null
  
)

export default component.exports